const KB = 1024;
const MB = KB * 1024;

export function formatFileSize(bytes: number): string {
  if (bytes >= MB) {
    return `${Math.round(bytes / MB)}MB`;
  }

  if (bytes >= 100 * KB) {
    const mb = Math.round((bytes / MB) * 10) / 10;
    return mb >= 1 ? `${Math.round(mb)}MB` : `${mb.toFixed(1)}MB`;
  }

  return `${Math.max(1, Math.round(bytes / KB))}KB`;
}
